// import { useState, useEffect } from 'react';
// import axios from '../axios'
// import { format } from 'date-fns';
// import { handleResponse } from 'src/utils/responseHandler';
// import { getURL } from 'src/utils/config';
// import { ceil } from 'lodash';


// const useDashboard = () => {

//     const baseURL = '/dashboard'
//     const RUN_FREQ_TIME = 60 //Sec
//     const ANALYTICS_ICONS = {
//         'person': 'mdi:biathlon',
//         'vehicle': 'mdi:bus',
//         'fire': 'mdi:fire',
//         'smoke': "material-symbols:detector-smoke",
//         'accident': 'maki:road-accident',
//         'clapping': 'emojione-v1:clapping-hands',
//         'cycling': "game-icons:cycling",
//         'drinking': 'cil:drink',
//         'sleepatwork': 'iconoir:sleeper-chair',
//         'eating': 'fluent-mdl2:eat-drink',
//         'listening_to_music': 'arcticons:google-music',
//         'running': 'cil:running',
//         'sitting': 'game-icons:sitting-dog',
//         'texting': 'bi:chat-text',
//         'using_laptop': 'emojione:laptop-computer',
//         'animal': 'game-icons:elephant',
//         'cops': 'fluent-emoji:man-police-officer',
//         'delivery': 'emojione:delivery-truck',
//         'spillage': 'openmoji:oil-spill',
//         'firesmoke': 'emojione:fire',
//         'social_distance': 'ic:sharp-social-distance',
//         'sefty_jocket': 'game-icons:life-jacket',
//         'helmet ': 'emojione:rescue-workers-helmet',
//         'gloves': 'noto:gloves',
//         'dark': 'arcticons:dark',
//         'person': 'el:person',
//         'vehicle': 'fluent:vehicle-cab-16-regular',
//         'mob': 'fluent:people-audience-20-regular',
//         'face_recognition': 'emojione:anguished-face',
//         'attendence': 'charm:person',
//         'vehicle_speed': 'fluent:top-speed-24-regular',
//         'license_plate_recognition': 'bx:car',
//         'smoking': 'cil:smoking-room'
//     }

//     const [alldata, seData] = useState({
//         isGetData: true,
//         response: [],
//         data: []
//     })

//     const [graph, setGraph] = useState({        
//         isGetData: true,
//         data: {},
//         total: 0
//     })

//     const jsonToParam = (data) => {
//         return Object.keys(data).map(function (k) {
//             return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
//         }).join('&')
//     }


//     useEffect(() => {      




//         getAnalyticsCount()    
//         // getAuditData() 
//         getAnalyticsCountByDate()   
//         const intervalId = setInterval(() => {
//             isReloadData(true)
//         }, 1000*RUN_FREQ_TIME)
//         return () => clearInterval(intervalId)

//     }, [alldata.isGetData])   


//     const getAnalyticsCount = (fromdate=null, todate=null) => {

//         const clientId =  localStorage.getItem('client_id');

//             if (clientId === '1118') {
//                 // Get current date and time
//                 let currentDay = new Date();
//                 let currentHour = currentDay.getHours();
//                 let currentMinute = currentDay.getMinutes();

//                 // Check if the current time is before 5:00 AM
//                 if (currentHour < 5 || (currentHour === 5 && currentMinute === 0)) {
//                     // If it's before 5 AM, set 'fromdate' to the previous day at 05:00:00 AM
//                     let previousDay = new Date();
//                     previousDay.setDate(previousDay.getDate() - 1);  // Move back one day
//                     fromdate = format(previousDay, 'yyyy-MM-dd') + ' 05:00:00';

//                     // Set 'todate' to the current day at 05:00:00 AM
//                     todate = format(currentDay, 'yyyy-MM-dd') + ' 05:00:00';
//                 } else {
//                     // If it's after 5 AM, set 'fromdate' to the current day at 05:00:00 AM
//                     fromdate = format(currentDay, 'yyyy-MM-dd') + ' 05:00:00';

//                     // Set 'todate' to the next day at 05:00:00 AM
//                     let nextDay = new Date();
//                     nextDay.setDate(nextDay.getDate() + 1);  // Move forward one day
//                     todate = format(nextDay, 'yyyy-MM-dd') + ' 05:00:00';
//                 }
//             }


//             else{
//                 fromdate = format(new Date(), 'yyyy-MM-dd') + ' 00:00:00';  // Set hours, minutes, and seconds to 00:00:00
//                 todate = format(new Date(), 'yyyy-MM-dd') + ' 23:59:59';    // Set hours, minutes, and seconds to 23:59:59

//             } 

//         let bodyContent = jsonToParam({
//             "fromdate":fromdate,
//             "todate": todate
//         });

//         // let bodyContent = jsonToParam({
//         //     "fromdate": "2024-10-08 05:00:00",
//         //     "todate": "2024-10-09 05:00:00"
//         // });

//         // console.log("=======body=====",bodyContent);

//         let url = `${baseURL}/audits?${bodyContent}`
//         if (alldata.isGetData) {
//             axios({
//                 method: 'get',
//                 url: getURL(url),
//                 validateStatus: (status) => handleResponse(status)
//             }).then((response) => {
//                 // console.log(response.data)
//                 if (response.status === 200 || response.status === 201) {
//                     seData({
//                         ...alldata,
//                         response: response.data,
//                         data: response.data,
//                         isGetData: false                        
//                     })
//                 }
//                 // getAnalyticsCountByDate()
//             })
//         }
//     }






//     const getAnalyticsCountByDate = (fromdate=null, todate=null) => {
//         const clientId =  localStorage.getItem('client_id');


//         if (!fromdate || !todate) {


//             if (clientId === '1118') {
//                 // Get current date and time
//                 let currentDay = new Date();
//                 let currentHour = currentDay.getHours();
//                 let currentMinute = currentDay.getMinutes();

//                 // Check if the current time is before 5:00 AM
//                 if (currentHour < 5 || (currentHour === 5 && currentMinute === 0)) {
//                     // If it's before 5 AM, set 'fromdate' to the previous day at 05:00:00 AM
//                     let previousDay = new Date();
//                     previousDay.setDate(previousDay.getDate() - 1);  // Move back one day
//                     fromdate = format(previousDay, 'yyyy-MM-dd') + ' 05:00:00';

//                     // Set 'todate' to the current day at 05:00:00 AM
//                     todate = format(currentDay, 'yyyy-MM-dd') + ' 05:00:00';
//                 } else {
//                     // If it's after 5 AM, set 'fromdate' to the current day at 05:00:00 AM
//                     fromdate = format(currentDay, 'yyyy-MM-dd') + ' 05:00:00';

//                     // Set 'todate' to the next day at 05:00:00 AM
//                     let nextDay = new Date();
//                     nextDay.setDate(nextDay.getDate() + 1);  // Move forward one day
//                     todate = format(nextDay, 'yyyy-MM-dd') + ' 05:00:00';
//                 }
//             }


//             else{
//                 fromdate = format(new Date(), 'yyyy-MM-dd') + ' 00:00:00';  // Set hours, minutes, and seconds to 00:00:00
//                 todate = format(new Date(), 'yyyy-MM-dd') + ' 23:59:59';    // Set hours, minutes, and seconds to 23:59:59

//             }

//         }    

//         let bodyContent = jsonToParam({
//             "fromdate": fromdate,
//             "todate": todate
//         });


//         // let bodyContent = jsonToParam({
//         //     "fromdate": "2024-10-08 05:00:00",
//         //     "todate": "2024-10-09 05:00:00"
//         // });


//         let url = `${baseURL}/audits-by-date?${bodyContent}`

//         if (graph.isGetData) {
//             axios({
//                 method: 'get',
//                 url: getURL(url),
//                 validateStatus: (status) => handleResponse(status)
//             }).then((response) => {
//                 if (response.status === 200 || response.status === 201) {
//                 //    console.log("==============================",manageDateWiseData(response.data))

//                     const [ total, data ] = manageDateWiseData(response.data)
//                     setGraph({
//                         ...graph,
//                         data: data,
//                         isGetData: false,
//                         total: total                     
//                     })
//                 }
//             })
//         }

//     }

//     const jsonToDict = (res) => {
//         let data = {}
//         for (let a of res)
//             data[parseInt(a.hour)] = a.count
//         return data
//     }

//     const manageDateWiseData = (res) => {
//         let total = 0
//         let data = jsonToDict(res)
//         const today = {}
//         let last = 0
//         let day = ''
//         const clientID = localStorage.getItem('client_id')
//         if (clientID === '1118') {
//             // Initialize variables for the first day start and total
//             let total = 0;
//             let last = 5; // Starting from 5 AM
//             let today = {};

//             // Loop through the day intervals from 5 AM to midnight (12 AM)
//             for (let n = 6; n <= 24; n++) { // From 5 AM to 12 AM (midnight)
//                 let day = `${last}-${n}`; // Represent the day interval as a string (e.g., "5-6")
//                 today[day] = 0; // Initialize the total for this interval

//                 // Sum the data points from 'last' to 'n'
//                 for (let x = last; x < n; x++) {
//                     today[day] += x in data ? data[x] : 0; // Accumulate data
//                 }

//                 // Add the total for this period to the overall total
//                 total += parseInt(today[day]);

//                 // Update the start time (last) for the next iteration
//                 last = n;
//             }

//             // For the remaining hours from midnight to 5 AM the next day
//             for (let n = 0; n < 5; n++) { // Loop through from 12 AM to 5 AM (next day)
//                 let nextTime = (last + 1) % 24;  // Calculate the time after 1 hour
//                 let day = `${last}-${nextTime}`; // Represent the interval (e.g., "24-1", "1-2")
//                 today[day] = 0; // Initialize the total for this interval

//                 // Sum the data points for this 1-hour period
//                 for (let x = last; x < nextTime; x++) {
//                     today[day] += x in data ? data[x] : 0; // Accumulate data
//                 }

//                 // Add the total for this period to the overall total
//                 total += parseInt(today[day]);

//                 // Update the start time (last) for the next 1-hour interval
//                 last = nextTime;
//             }

//             // Return the total and the daily data
//             return [total, today];
//         }




//         else{
//             for (let n=3; n<=24; n+=3) {
//                 day = `${last}-${n}`
//                 today[day] = 0
//                 for (let x=last; x<n; x++)
//                     today[day] += x in data ? data[x]: 0
//                     total += parseInt(today[day])
//                 last = n
//             }
//             return [ total, today ]
//         }

//     }

//     const isReloadData = (status) => {
//         seData({ ...alldata, isGetData: status })
//         setGraph({ ...graph, isGetData: status })
//     }

//     const getIcon = (analytic) =>  analytic ? (analytic.toLowerCase() in ANALYTICS_ICONS ? ANALYTICS_ICONS[analytic.toLowerCase()]: 'ant-design:dot-chart-outlined') : 'ant-design:dot-chart-outlined'

//     return {
//         alldata,
//         graph,
//         getIcon,
//         isReloadData
//     }
// }

// export default useDashboard

// block-1

// File: src/api/useDashboard.js

import { useState, useEffect } from 'react';
import axios from '../axios';
import { handleResponse } from 'src/utils/responseHandler';
import { getURL } from 'src/utils/config';
import { getClientAudits } from './clientDetails';
import { format } from 'date-fns';

const ANALYTICS_ICONS = {
  person: 'mdi:biathlon',
  vehicle: 'mdi:bus',
  smoking: 'cil:smoking-room',
  falsemembershipusage: 'mdi:account-cancel',            // Better reflects an invalid or canceled membership
  weightsrerackviolation: 'mdi:dumbbell',               // Use gym equipment (dumbbell) icon for equipment misuse
  tailgating: 'mdi:account-multiple',                           // Represents unauthorized entry (following someone in)
  // liveoccupancy: 'mdi:account-group' ,
  falldetection: 'material-symbols:sports-handball-rounded'
};

// mdi:shuffle-variant
// mdi:arrow-expand-all

const useDashboard = ({ clientId, location, timeRange }) => {
  const baseURL = '/dashboard';
  const RUN_FREQ_TIME = 60; // seconds

  const [alldata, setAllData] = useState({ isGetData: true, response: [], data: [] });
  // const [graph, setGraph] = useState({ isGetData: true, data: {}, total: 0 });

  const [dateRange, setDateRange] = useState({ from: null, to: null });

  const [recentEvents, setRecentEvents] = useState([])
  const [cameraInfo, setCameraInfo] = useState([])
  const [topCameras, setTopCamerasInfo] = useState([])
  
  const locationInfo =
    [
      {
        "Id": 11,
        "LocationName": "Stamford",
        "online": 10,
        "offline": 0,
        "address": "316 Courtland Ave, 2nd Floor, Stamford, Ct 06906"

      },
      {
        "Id": 12,
        "LocationName": "Wallingford",
        "online": 10,
        "offline": 0,
        "address": "10 Capital Drive, Wallingford, Ct"

      },
      {
        "Id": 13,
        "LocationName": "Orange",
        "online": 8,
        "offline": 0,
        "address": "385 Boston Post Rd Orange, Ct"

      },
      {
        "Id": 16,
        "LocationName": "Branford",
        "online": 12,
        "offline": 0,
        "address": "251 W Main Street, Branford, Ct 06405"

      },
      {
        "Id": 15,
        "LocationName": "West Hartford",
        "online": 10,
        "offline": 0,
        "address": "17 Andover Drive, West Hartford, Ct 06451"

      },
      {
        "Id": 14,
        "LocationName": "Stratford",
        "online": 10,
        "offline": 0,
        "address": "300 Long Beach Blvd, Stratford, Ct 06615"

      }
    ];

  const [filteredLocationInfo, setFilteredLocationInfo] = useState(null);

  const jsonToParam = (data) =>
    Object.keys(data)
      .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(data[k]))
      .join('&');

  const calculateDateRange = (days) => {
    // const now = new Date();
    // const to = now.toISOString().slice(0, 19).replace('T', ' ');
    // const fromDate = new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
    // const from = fromDate.toISOString().slice(0, 19).replace('T', ' ');
    // return { from, to };

    const now = new Date();
    const to = format(now, 'yyyy-MM-dd HH:mm:ss');
    const fromDate = new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
    const from = format(fromDate, 'yyyy-MM-dd HH:mm:ss');
    return { from, to };
  };

  const getAnalyticsCount = (fromdate, todate, locationId) => {
    const location_id = locationId
    const bodyContent = jsonToParam({ fromdate, todate, location_id });
    const url = `${baseURL}/audits?${bodyContent}`;

    axios.get(getURL(url)).then((response) => {
      if (response.status === 200 || response.status === 201) {

        // const responseData = [
        //   ...response.data,
        //   ...(locationId === 11
        //     ? [{
        //       Name: "Live Occupancy",
        //       cunt: 30
        //     }]
        //     : [])
        // ]

        const responseData = [
          ...response.data
        ] 

        setAllData({
          isGetData: false,
          response: response.data,
          data: responseData
        });
      }
    });
  };

  // const getAnalyticsCountByDate = (fromdate, todate, locationId) => {
  //   const bodyContent = jsonToParam({ fromdate, todate, locationId });
  //   const url = `${baseURL}/audits-by-date?${bodyContent}`;

  //   axios.get(getURL(url)).then((response) => {
  //     if (response.status === 200 || response.status === 201) {
  //       const [total, data] = manageDateWiseData(response.data);
  //       setGraph({
  //         isGetData: false,
  //         total,
  //         data
  //       });
  //     }
  //   });
  // };

  const jsonToDict = (res) => {
    let data = {};
    for (let a of res) data[parseInt(a.hour)] = a.count;
    return data;
  };

  const manageDateWiseData = (res) => {
    let total = 0;
    let data = jsonToDict(res);
    let today = {};
    let last = 0;

    for (let n = 3; n <= 24; n += 3) {
      let day = `${last}-${n}`;
      today[day] = 0;
      for (let x = last; x < n; x++) {
        today[day] += data[x] || 0;
      }
      total += today[day];
      last = n;
    }

    return [total, today];
  };

  const isReloadData = (status) => {
    setAllData({ ...alldata, isGetData: status });
    //setGraph({ ...graph, isGetData: status });
  };

  const getIcon = (analytic) =>
    analytic && ANALYTICS_ICONS[analytic.toLowerCase()]
      ? ANALYTICS_ICONS[analytic.toLowerCase()]
      : 'ant-design:dot-chart-outlined';

  const fetchClientAudits = (locationId, fromdate, todate) => {
    const bodyLimit = {
      limit: 3,
      location_id: Number(locationId),
      // fromdate,
      // todate
    };
    getClientAudits(bodyLimit, (auditResponse) => {
      if (auditResponse.status === 200 && auditResponse.data.length > 0) {
        setRecentEvents(auditResponse.data);
      } else {
        setRecentEvents([]);
      }
    });
  };



  useEffect(() => {
    if (location || timeRange) {
      const { from, to } = calculateDateRange(Number(timeRange));
      setDateRange({ from, to });
      if (location) {
        getAnalyticsCount(from, to, location);
        fetchClientAudits(location, from, to);
        //fetchClientCameras(clientId,location);

        const selectedLocationData = locationInfo.find((loc) => loc.Id === Number(location));
        setFilteredLocationInfo(selectedLocationData || null);
      }
      //getAnalyticsCountByDate(from, to, location);
    }
  }, [location, timeRange]);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     isReloadData(true);
  //   }, 1000 * RUN_FREQ_TIME);
  //   return () => clearInterval(intervalId);
  // }, []);


  useEffect(() => {
    const intervalId = setInterval(() => {
      if (location && timeRange) {
        isReloadData(true);
        const { from, to } = calculateDateRange(Number(timeRange));
        if (location) {
          getAnalyticsCount(from, to, location);
        }
        //getAnalyticsCountByDate(from, to, location);
      }
    }, 1000 * RUN_FREQ_TIME);
    return () => clearInterval(intervalId);
  }, [location, timeRange]);


  return {
    recentEvents,
    alldata,
    //graph,
    getIcon,
    dateRange,
    location,
    filteredLocationInfo
  };
};

export default useDashboard;